import common from './pt/common.json';

const translation = {
  ...common,
};

export default translation;
